import * as React from "react";

export function SunIcon() {
    return (
        <svg
            aria-hidden="true"
            viewBox="0 0 24 24"
            width="16"
            height="16"
            focusable="false"
            style={{ display: "block" }}
        >
            <circle cx="12" cy="12" r="4.25" fill="currentColor" />
            <g
                stroke="currentColor"
                strokeLinecap="round"
                strokeWidth="1.8"
                fill="none"
            >
                <path d="M12 2.75v3" />
                <path d="M12 18.25v3" />
                <path d="M2.75 12h3" />
                <path d="M18.25 12h3" />
                <path d="M5.4 5.4l2.1 2.1" />
                <path d="M16.5 16.5l2.1 2.1" />
                <path d="M18.6 5.4l-2.1 2.1" />
                <path d="M7.5 16.5l-2.1 2.1" />
            </g>
        </svg>
    );
}

export function MoonIcon() {
    return (
        <svg
            aria-hidden="true"
            viewBox="0 0 24 24"
            width="16"
            height="16"
            focusable="false"
            style={{ display: "block" }}
        >
            <path
                d="M15.7 3.4c-1.2.2-2.2.7-3.1 1.4-1.5 1.3-2.4 3.2-2.4 5.3 0 3.8 3.1 6.9 6.9 6.9 1.1 0 2.2-.3 3.1-.8A8.98 8.98 0 0 1 12 21c-5 0-9-4-9-9 0-4.5 3.4-8.3 7.8-8.9.9-.1 1.8-.1 2.6.3.5.2.8.7.7 1.2-.1.5-.4.8-.9.8H15.7Z"
                fill="currentColor"
            />
        </svg>
    );
}
